import {I18n, loadTranslations, setLocale, syncTranslationWithStore} from 'react-redux-i18n';
import en from './en';
import fr from './fr';
import de from './de';
import it from './it';

let localStore;

const translations = {
  en,
  fr,
  de,
  it
};

export const availableLanguages = Object.keys(translations);

function getDefaultLocale() {
  // Define user's language. Different browsers have the user locale defined
  // on different fields on the `navigator` object, so we make sure to account
  // for these different by checking all of them
  const language =
    (navigator.languages && navigator.languages[0]) ||
    navigator.language ||
    navigator.userLanguage;

  // Split locales with a region code
  return language ? language.toLowerCase().split(/[_-]+/)[0] : 'en';
}

export default function initTranslations(store, language) {
  const persistedLanguage = language || getDefaultLocale();

  localStore = store;
  syncTranslationWithStore(localStore);
  localStore.dispatch(loadTranslations(translations));

  // By default, if the default browser language is not recognized ==> English
  localStore.dispatch(setLocale(availableLanguages.includes(persistedLanguage) ? persistedLanguage : 'en'));
}

export function translateToLocale(locale, key, replacements = {}) {
  I18n.setLocaleGetter(() => locale);
  const translation = I18n.t(key, replacements);
  syncTranslationWithStore(localStore);
  return translation;
}
